<script>
export default {
  props: {
    markRequired: {
      type: Boolean,
      default: false,
    },
    size: { type: String, default: 'sm' },
    label: { type: String, default: '' },
    newStyle: { type: Boolean, default: false },
  },
}
</script>
<template>
  <div
    :class="{
      [$style.eLabel]: true,
      [$style.labelMargin]: size === 'md',
      [$style.formFieldLabel]: size === 'sm',
      [$style.redesignedLabel]: newStyle,
    }"
  >
    {{ label }}
    <span v-if="markRequired" class="text-danger">*</span>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.eLabel {
  display: inline-block;
  margin: 0.325rem 0;
}
.labelMargin {
  font-size: $size-font-sub-header;
  font-weight: $heading-font-weight;
  color: $color-subheader;
}
.formFieldLabel {
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}
.redesignedLabel {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px; 
  color: $color-raisin-100;
}
</style>
